import { delayOffset } from "@/lib/animation";

const selectors = {
  animationItems: ".animation--item",
};

export default node => {
  function animate() {
    // Add the animation delay offset variables
    delayOffset(node, [selectors.animationItems]);
  }

  return {
    animate
  };
};
